import { useEffect, useRef, useState } from "react";
import CommonTable from "../../../components/comman/CommonTable";
import MainHeading from "../../../components/comman/MainHeading";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { callApi } from "../../../ApiHelper/ApiHelper";
import moment from "moment";
import {
  calculateHours,
  checkUserAccess,
  formatTo12HourTime,
  printData,
} from "../../../utility/CommonFunctions";
import { toast } from "react-toastify";
import FilterComponent from "../../../components/comman/FilterComponent";
import { useDispatch, useSelector } from "react-redux";
import { Nav, NavItem, NavLink, TabContent, Fade, TabPane } from "reactstrap";
import AddLeaveModal from "../Leave/AddLeaveModal";
import { updateFiltersStates } from "../../../store/actions/UserActions";

export default function TeamAttendance() {
  const userDetails = useSelector((state) => state.root.userDetails);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const dispatch = useDispatch();
  const [state, setState] = useState({
    officeList: null,
    userList: null,
    attendanceList: [],
  });
  const [pageStates, setPageStates] = useState({
    activeTab: 1,
    ...(checkUserAccess(userDetails).isUserAccess
      ? { staffType: "1" }
      : { staffType: "0" }),
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    searchQuery: "",
    tableLoader: false,
    attendanceStatus: "",
    attendanceType: "",
    sortBySingleDate: [
      moment().format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ],
    siteId: filterDetails?.siteId,
    officeName: "",
    user: "",
    officeType: "",
    departmentList: [],
    designationList: [],
    department: "",
    designation: "",
    companyList: [],
    siteList: [],
    companyId: "",
    userName: "",
    companyIsLoading: false,
    isInitial: true,
    isLoadingSite: false,
  });
  const [modal, setModal] = useState(false);
  const timeoutId = useRef(null);

  const toggleModal = () => {
    setModal(!modal);
  };

  const toggleTab = (tab) => {
    if (tab == 1) {
      setPageStates((prev) => ({
        ...prev,
        staffType: "1",
        activeTab: tab,
        currentPage: 1,
        siteId: "",
        department: "",
        designation: "",
        companyId: "",
        attendanceStatus: "",
        attendanceType: "",
        departmentList: [],
        designationList: [],
      }));
      dispatch(
        updateFiltersStates({
          companyId: "",
        })
      );
      getDepartmentAndDesignation("office");
    } else {
      dispatch(
        updateFiltersStates({
          companyId: "",
        })
      );
      setPageStates((prev) => ({
        ...prev,
        staffType: "0",
        activeTab: tab,
        currentPage: 1,
        siteId: filterDetails?.siteId,
        department: "",
        designation: "",
        companyId: "",
        attendanceStatus: "",
        attendanceType: "",
        departmentList: [],
        designationList: [],
      }));
      // getSite();
      getDepartmentAndDesignation("site");
    }
  };

  useEffect(() => {
    if (checkUserAccess(userDetails).isUserAccess) {
      getDepartmentAndDesignation("office");
      getSite();
    } else {
      getDepartmentAndDesignation("site");
      getSite();
    }
  }, []);

  useEffect(() => {
    GetAttendance();
  }, [
    pageStates?.sortBySingleDate,
    pageStates?.currentPage,
    pageStates.user,
    pageStates?.searchQuery,
    pageStates?.attendanceStatus,
    pageStates?.attendanceType,
    pageStates?.staffType,
    pageStates?.officeName,
    pageStates.pageSize,
    filterDetails?.siteId,
    filterDetails?.companyId,
    pageStates?.department,
    pageStates?.designation,
  ]);

  useEffect(() => {
    GetCompanyList();
  }, []);

  const GetAttendance = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_attendance +
      "?myAttendance=false&from=todayAtt&" +
      MainFilterHandler({
        ...pageStates,
        siteId: pageStates.activeTab == 1 ? "" : pageStates?.siteId,
        companyId: filterDetails?.companyId,
      });
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.attendance?.map((item) => ({
          ...item,
          empNameWithImage: item?.name + "##" + item?.profilePhoto,
          attendanceDate: moment(item?.attendances[0]?.checkInTime).format(
            "DD/MM/YYYY"
          ),
          shiftTime: item?.Shift?.shiftName,
          departmentName: item?.department?.name,
          onRollCompany: item?.Company?.name,
          officeName: item?.site?.name,
          siteName: item?.usersites?.[0]?.site?.name,
          attendanceType: item?.attendances[0]?.isODrequest
            ? "OD Request"
            : item?.attendances[0]?.isARrequest
              ? "AR Request"
              : item?.attendances[0]?.status == 3
                ? "Leave"
                : "General",
          attendanceStatusToggle: item?.attendances[0]
            ? item?.attendances[0]?.status
            : 2,
          checkIn:
            item?.attendances[0]?.checkInTime &&
            formatTo12HourTime(item?.attendances[0]?.checkInTime),
          checkOut:
            item?.attendances[0]?.checkOutTime &&
            formatTo12HourTime(item?.attendances[0]?.checkOutTime),
          totalDuration:
            item?.attendances[0]?.checkOutTime &&
            calculateHours(
              item?.attendances[0]?.checkInTime,
              item?.attendances[0]?.checkOutTime
            ),
          designationName: item?.designation?.name,
        }));

        setState((pre) => ({
          ...pre,
          attendanceList: newData,
        }));
        setPageStates((pre) => ({
          ...pre,
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const GetCompanyList = (inputValue = null) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };

      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));

      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const getDepartmentAndDesignation = (type, id) => {
    const url =
      type === "designation"
        ? apiUrl.get_designation + `?departmentId=${id}`
        : apiUrl.get_department + `?type=${type}`;
    callApi(url, { method: "GET" }).then((res) => {
      if (res?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          ...(type === "designation"
            ? {
              designationList: res?.data?.designation,
              // designation: ""
            }
            : { departmentList: res?.data?.department }),
        }));
      }
    });
  };

  // printData(pageStates);
  const getSite = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      const API =
        apiUrl?.get_user_site +
        `?pageSize=100` +
        (companyId ? `&companyId=${companyId}` : "") +
        (searchQuery ? `&search=${searchQuery}` : "");

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item.site?.id,
              label: item?.site?.name,
            }));

            const siteId = response.data?.site?.some(
              (item) => item.site?.id == filterDetails?.siteId
            );
            setPageStates((prev) => ({
              ...prev,
              ...(siteId ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const TableHeadingOffice = [
    { value: "employeeCode", label: "Emp. Code" },
    { value: "empNameWithImage", label: "Employee" },
    // { value: "attendanceDate", label: "Date" },
    { value: "attendanceStatusToggle", label: "Status" },
    { value: "checkIn", label: "Check In" },
    { value: "checkOut", label: "Check Out" },
    { value: "totalDuration", label: "Total Duration" },
    { value: "attendanceType", label: "Attendance Type" },
    { value: "shiftTime", label: "Shift" },
    { value: "departmentName", label: "Department" },
    { value: "designationName", label: "Designation" },
    { value: "onRollCompany", label: "On Roll Company" },
    { value: "officeName", label: "Office" },
  ];

  const TableHeadingSite = [
    { value: "employeeCode", label: "Emp. Code" },
    { value: "empNameWithImage", label: "Employee" },
    // { value: "attendanceDate", label: "Date" },
    { value: "attendanceStatusToggle", label: "Status" },
    { value: "checkIn", label: "Check In" },
    { value: "checkOut", label: "Check Out" },
    { value: "totalDuration", label: "Total Duration" },
    { value: "attendanceType", label: "Attendance Type" },
    { value: "shiftTime", label: "Shift" },
    { value: "departmentName", label: "Department" },
    { value: "designationName", label: "Designation" },
    { value: "onRollCompany", label: "On Roll Company" },
    { value: "siteName", label: "Site" },
  ];

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "empNameWithImage", label: "Employee" },
    // { value: "attendanceDate", label: "Date" },
    { value: "attendanceStatusToggle", label: "Status" },
    { value: "checkIn", label: "Check In" },
    { value: "checkOut", label: "Check Out" },
    { value: "totalDuration", label: "Total Duration" },
    { value: "attendanceType", label: "Attendance Type" },
    { value: "shiftTime", label: "Shift" },
    { value: "departmentName", label: "Department" },
    { value: "designationName", label: "Designation" },
    { value: "siteName", label: "Site" },
  ];

  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const singleDateChangeHandler = (date) => {
    let formattedDate = null;

    if (date) {
      formattedDate = new Date(
        date.getTime() - date.getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
    }

    setPageStates((prevState) => ({
      ...prevState,
      sortBySingleDate: formattedDate
        ? [moment(formattedDate).format("YYYY-MM-DD")]
        : [],
    }));
  };

  const handleData = (data, type = null) => {
    setPageStates((pre) => ({
      ...pre,
      ...(!type && { attendanceStatus: data?.attendanceStatus }),
      ...(!type && { attendanceType: data?.attendanceType }),
      ...(!type && { department: data?.department }),
      ...(!type && { designation: data?.designation }),
      ...(type == "site" && { siteId: data?.site }),
      ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type == "site" && { siteId: data?.site }),
        ...(type === "companyId" && { companyId: data?.companyId }),
      })
    );
    if (type === "department" && data?.department) {
      getDepartmentAndDesignation("designation", data?.department);
    }
    if (type === "companyId" && data?.companyId && pageStates.activeTab == 2) {
      getSite(data?.companyId);
    }
  };

  const sortListSite = {
    // userList: state?.userList,
    department: pageStates?.departmentList,
    designation: pageStates?.designationList,
    attendanceStatus: [
      { value: "", label: "Select Attendance Status" },
      { value: 1, label: "Present" },
      { value: 0, label: "Absent" },
      { value: 2, label: "Pending" },
      { value: 3, label: "On Leave" },
    ],
    attendanceType: [
      { value: "", label: "Select Attendance Type" },
      { value: "odRequest", label: "OD Request" },
      { value: "arRequest", label: "AR equest" },
      { value: "general", label: "General" },
      { value: "leave", label: "Leave" },
    ],
    ...(pageStates.activeTab === 2 && { site: pageStates?.siteList }),
    companyList: pageStates?.companyList,
    resetState: pageStates.activeTab,
  };

  const sortListOffice = {
    // userList: state?.userList,
    department: pageStates?.departmentList,
    designation: pageStates?.designationList,
    attendanceStatus: [
      { value: "", label: "Select Attendance Status" },
      { value: 1, label: "Present" },
      { value: 0, label: "Absent" },
      { value: 2, label: "Pending" },
      { value: 3, label: "On Leave" },
    ],
    attendanceType: [
      { value: "", label: "Select Attendance Type" },
      { value: "odRequest", label: "OD Request" },
      { value: "arRequest", label: "AR equest" },
      { value: "general", label: "General" },
      { value: "leave", label: "Leave" },
    ],
    site: pageStates?.siteList,
    companyList: pageStates?.companyList,
    resetState: pageStates.activeTab,
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        currentPage: 1,
        searchQuery: value,
      }));
    }, 300);
  };

  const getLeaveCount = (data) => {
    const option = {
      method: "GET",
    };
    const url =
      apiUrl.get_leave_count + `?type=${data?.type}&userId=${data?.userId}`;
    callApi(url, option).then((res) => {
      if (res?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          listType: res?.data,
          userName: data?.userName,
          userId: data?.userId,
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  // console.log(pageStates?.sortBySingleDate)

  const handleChangeAttendance = (newStatus, userId, userName) => {
    if (newStatus !== 3) {
      const submitData = {
        userId: userId,
        markingAttendance: true,
        status: newStatus,
        date: pageStates?.sortBySingleDate[0],
      };
      let options = {
        method: "POST",
        data: submitData,
      };
      const url = apiUrl.mark_attendance;
      callApi(url, options).then((res) => {
        if (res?.status === true) {
          toast.success("Attendance Updated");
          GetAttendance(pageStates?.currentPage);
        } else {
          toast.error(res?.message);
        }
      });
    } else {
      const data = {
        userName: userName,
        userId: userId,
        type: "remaining",
      };
      getLeaveCount(data);
      toggleModal();
      // printData(newStatus);
    }
  };

  // console.log("sortBySingledate=========>", pageStates?.sortBySingleDate);

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Team Attendance"}
          singleDateChangeHandler={singleDateChangeHandler}
          pageState={pageStates}
        // team={true}
        // buttonText={"Apply Leave"}
        // buttonIcon={<PlusIcon />}
        // buttonLink={RoutesLink?.add_customer}
        // clickHandler={toggleModal}
        />
        {checkUserAccess(userDetails).isUserAccess ? (
          <>
            <Nav tabs className="nav nav-tabs border-0 mb-4">
              <NavItem className="nav-item">
                <NavLink
                  className={
                    pageStates?.activeTab === 1
                      ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2 active"
                      : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2"
                  }
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleTab(1)}
                >
                  Office Staff Attendance
                </NavLink>
              </NavItem>
              <NavItem className="nav-item ">
                <NavLink
                  className={
                    pageStates?.activeTab === 2
                      ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                      : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                  }
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleTab(2)}
                >
                  Site Staff Attendance
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={pageStates?.activeTab}>
              <TabPane tabId={1}>
                <Fade in={pageStates?.activeTab === 1} timeout={200}>
                  <div className="card mb-4">
                    <div className="card-body">
                      <FilterComponent
                        handleSearch={handleSearchChange}
                        searchPlaceHolder={"Search by Employee"}
                        // exportBtn={true}
                        filterArray={sortListSite}
                        pageState={pageStates}
                        // leaveList={state?.siteList}
                        handleData={handleData}
                        sortHandler={handleData}
                        pageStates={pageStates}
                        getCompany={GetCompanyList}
                      // tableDataForExport={state?.attendanceList}
                      // exportFileName={"Office_Staff_Attendance_Data"}
                      // exportColumns={[
                      //   "empName",
                      //   "attendanceDate",
                      //   "shiftTime",
                      //   "departmentName",
                      //   "officeName",
                      //   "attendanceType",
                      //   "status",
                      //   "checkIn",
                      //   "checkOut",
                      //   "totalDuration",
                      // ]}
                      />
                      <CommonTable
                        TableHeading={TableHeadingOffice}
                        TableData={state?.attendanceList}
                        currentPage={pageStates?.currentPage}
                        PageChangeHandler={PageChangeHandler}
                        isLoading={pageStates?.tableLoader}
                        totalPages={pageStates?.totalPages}
                        count={pageStates?.count}
                        handleChangePageSize={handleChangePageSize}
                        pageSize={pageStates.pageSize}
                        handleChangeAttendance={handleChangeAttendance}
                      />
                    </div>
                  </div>
                </Fade>
              </TabPane>
              <TabPane tabId={2}>
                <Fade in={pageStates?.activeTab === 2} timeout={200}>
                  <div className="card mb-4">
                    <div className="card-body">
                      <FilterComponent
                        // handleFilter={setPageStates}
                        handleSearch={handleSearchChange}
                        searchPlaceHolder={"Search by Employee"}
                        // exportBtn={true}
                        filterArray={sortListSite}
                        pageState={pageStates}
                        // dateChangeHandler={dateChangeHandler}
                        // handleFilterForAttendance={dateChangeHandler}
                        handleData={handleData}
                        sortHandler={handleData}
                        pageStates={pageStates}
                        getCompany={GetCompanyList}
                        getSite={getSite}
                      // tableDataForExport={state?.attendanceList}
                      // exportFileName={"Site_Staff_Attendance_Data"}
                      // exportColumns={[
                      //   "empName",
                      //   "attendanceDate",
                      //   "shiftTime",
                      //   "departmentName",
                      //   "siteName",
                      //   "attendanceType",
                      //   "status",
                      //   "checkIn",
                      //   "checkOut",
                      //   "totalDuration",
                      // ]}
                      />
                      <CommonTable
                        TableHeading={TableHeadingSite}
                        TableData={state?.attendanceList}
                        // CustomActionData={CustomActionData}
                        currentPage={pageStates?.currentPage}
                        PageChangeHandler={PageChangeHandler}
                        isLoading={pageStates?.tableLoader}
                        totalPages={pageStates?.totalPages}
                        count={pageStates?.count}
                        handleChangePageSize={handleChangePageSize}
                        pageSize={pageStates.pageSize}
                        handleChangeAttendance={handleChangeAttendance}
                      />
                    </div>
                  </div>
                </Fade>
              </TabPane>
            </TabContent>
          </>
        ) : (
          <div className="card mb-4">
            <div className="card-body">
              <FilterComponent
                handleSearch={handleSearchChange}
                searchPlaceHolder={"Search by Employee"}
                filterArray={sortListOffice}
                pageState={pageStates}
                // leaveList={state?.siteList}
                handleData={handleData}
                sortHandler={handleData}
                pageStates={pageStates}
                getCompany={GetCompanyList}
                getSite={getSite}
              // tableDataForExport={state?.attendanceList}
              // exportFileName={"Team_Attendance_Data"}
              // exportColumns={[
              //   "empName",
              //   "attendanceDate",
              //   "shiftTime",
              //   "departmentName",
              //   "siteName",
              //   "attendanceType",
              //   "status",
              //   "checkIn",
              //   "checkOut",
              //   "totalDuration",
              // ]}
              />
              <CommonTable
                TableHeading={TableHeading}
                TableData={state?.attendanceList}
                // ActionData={ActionData}
                currentPage={pageStates?.currentPage}
                PageChangeHandler={PageChangeHandler}
                isLoading={pageStates?.tableLoader}
                totalPages={pageStates?.totalPages}
                count={pageStates?.count}
                handleChangePageSize={handleChangePageSize}
                pageSize={pageStates.pageSize}
                handleChangeAttendance={handleChangeAttendance}
              />
            </div>
          </div>
        )}
      </div>
      <AddLeaveModal
        isOpen={modal}
        onClose={toggleModal}
        EditLeaveData={null}
        teamDate={pageStates?.sortBySingleDate?.[0]}
        Type={"leaveForUser"}
        state={pageStates}
        getAttendance={GetAttendance}
        markAttendance={true}
      />
    </>
  );
}
